import api from '@/lib/axios';
import type { PaginatedResult } from '@/components/data-table';

export interface NooraniTutorialRow {
  id: string;
  schoolId: string;
  schoolName: string;
  name: string;
  description: string | null;
  date: string;
  youtubeLink: string;
  groupIds: string[];
  groupNames: string[];
  createdAt: string;
  updatedAt: string;
}

export interface NooraniTutorialListParams {
  page?: number;
  limit?: number;
  search?: string;
  schoolId?: string;
  groupId?: string;
}

export interface CreateNooraniTutorialPayload {
  schoolId?: string;
  name: string;
  description?: string;
  date: string;
  youtubeLink: string;
  groupIds: string[];
}

export type UpdateNooraniTutorialPayload = Partial<Omit<CreateNooraniTutorialPayload, 'schoolId'>>;

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export const NooraniTutorialsApi = {
  list: async (params?: NooraniTutorialListParams): Promise<PaginatedResult<NooraniTutorialRow>> =>
    unwrap(await api.get('/noorani-tutorials', { params })),

  get: async (id: string): Promise<NooraniTutorialRow> => unwrap(await api.get(`/noorani-tutorials/${id}`)),

  create: async (payload: CreateNooraniTutorialPayload): Promise<NooraniTutorialRow> =>
    unwrap(await api.post('/noorani-tutorials', payload)),

  update: async (id: string, payload: UpdateNooraniTutorialPayload): Promise<NooraniTutorialRow> =>
    unwrap(await api.patch(`/noorani-tutorials/${id}`, payload)),

  remove: async (id: string): Promise<{ id: string }> => unwrap(await api.delete(`/noorani-tutorials/${id}`)),
};
